import * as React from 'react';
import { SearchIcon } from '../Icons';
import './SearchButton.styles.scss';

interface SearchButtonProps {
  toggleSearch: () => void;
}

/**
 * Renders an search button in the site's main navigation bar.
 */
export const SearchButton = ({ toggleSearch }: SearchButtonProps) => {
  return (
    <button
      id="search-btn"
      onClick={toggleSearch}
      className="flex align-center search-container">
      <div className="flex align-center">
        <SearchIcon />
        <span className="placeholder">Search...</span>
      </div>
      <div className="shortcut flex align-center">
        <span className="key">/</span>
      </div>
    </button>
  );
};
